import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgA3 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "A3",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "#BEF264"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 50.8867,
				y: 29.625,
				width: 6.07544,
				height: 8.50561,
				rx: 1.21509,
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 43.5962,
				y: 29.625,
				width: 6.07544,
				height: 8.50561,
				rx: 1.21509,
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.778 62.9494L56.9909 71.7898L56.9909 71.7898L54.778 62.9494ZM61.0239 60.1725L66.1033 67.7388L66.1033 67.7388L61.0239 60.1725ZM68.3546 51.1982L59.9293 47.7246L59.9293 47.7246L68.3546 51.1982ZM69.4872 39.6445L60.5475 41.4144L69.4872 39.6445ZM64.04 29.4058L57.581 35.8347L57.581 35.8347L64.04 29.4058ZM53.8491 23.9331L55.635 14.9966L55.635 14.9966L53.8491 23.9331ZM42.3494 25.071L45.8508 33.4847L42.3494 25.071ZM25.8288 27.3894C23.0416 31.5803 24.1795 37.2371 28.3704 40.0243C32.5613 42.8114 38.2181 41.6735 41.0052 37.4827L25.8288 27.3894ZM56.9909 71.7898C60.2227 70.9808 63.3077 69.6155 66.1033 67.7388L55.9445 52.6062C54.9055 53.3037 53.7614 53.8095 52.565 54.109L56.9909 71.7898ZM66.1033 67.7388C70.8756 64.5351 74.5888 59.986 76.7798 54.6717L59.9293 47.7246C59.1074 49.7182 57.7184 51.4153 55.9445 52.6062L66.1033 67.7388ZM76.7798 54.6717C78.9706 49.3578 79.5431 43.513 78.4268 37.8746L60.5475 41.4144C60.9672 43.534 60.7514 45.7306 59.9293 47.7246L76.7798 54.6717ZM78.4268 37.8746C77.3105 32.236 74.5539 27.0508 70.4991 22.9769L57.581 35.8347C59.0933 37.354 60.1279 39.295 60.5475 41.4144L78.4268 37.8746ZM70.4991 22.9769C66.4438 18.9026 61.2719 16.1231 55.635 14.9966L52.0632 32.8695C54.1481 33.2862 56.0692 34.3157 57.581 35.8347L70.4991 22.9769ZM55.635 14.9966C49.9979 13.8701 44.1554 14.4486 38.848 16.6573L45.8508 33.4847C47.8172 32.6663 49.9785 32.4529 52.0632 32.8695L55.635 14.9966ZM38.848 16.6573C33.5411 18.8659 29.0121 22.6029 25.8288 27.3894L41.0052 37.4827C42.196 35.6922 43.884 34.3032 45.8508 33.4847L38.848 16.6573ZM40.853 68.4029L40.853 82.4806L59.0793 82.4806L59.0793 68.4029L40.853 68.4029ZM52.565 54.109C47.2421 55.4415 40.853 60.3023 40.853 68.4029L59.0793 68.4029C59.0793 69.6863 58.5252 70.628 58.0782 71.1101C57.6769 71.543 57.2906 71.7148 56.9909 71.7898L52.565 54.109Z",
				fill: "url(#paint0_linear_7220_21629)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.999 82.2905C17.999 78.2641 21.2631 75 25.2895 75H46.5536C47.8957 75 48.9838 76.088 48.9838 77.4302V87.1509C48.9838 88.493 47.8957 89.5811 46.5536 89.5811H25.2895C21.2631 89.5811 17.999 86.317 17.999 82.2905Z",
				fill: "url(#paint1_linear_7220_21629)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82.6289 82.2925C82.6289 78.266 79.3648 75.002 75.3384 75.002H54.0743C52.7322 75.002 51.6442 76.09 51.6442 77.4321V87.1528C51.6442 88.495 52.7322 89.583 54.0743 89.583H75.3384C79.3648 89.583 82.6289 86.3189 82.6289 82.2925Z",
				fill: "url(#paint2_linear_7220_21629)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.355 24.7642C44.355 23.422 45.443 22.334 46.7852 22.334C48.1273 22.334 49.2153 23.422 49.2153 24.7642V27.1943C49.2153 28.5365 48.1273 29.6245 46.7852 29.6245C45.443 29.6245 44.355 28.5365 44.355 27.1943V24.7642Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.6455 24.7642C51.6455 23.422 52.7335 22.334 54.0757 22.334C55.4178 22.334 56.5059 23.422 56.5059 24.7642V27.1943C56.5059 28.5365 55.4178 29.6245 54.0757 29.6245C52.7335 29.6245 51.6455 28.5365 51.6455 27.1943V24.7642Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsxs("defs", { children: [
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint0_linear_7220_21629",
					x1: 51.6433,
					y1: 23.5488,
					x2: 51.6433,
					y2: 82.4806,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ECFCCB" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FEF9C3"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint1_linear_7220_21629",
					x1: 33.4914,
					y1: 75,
					x2: 33.4914,
					y2: 89.5811,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A3E635" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#84CC16"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint2_linear_7220_21629",
					x1: 67.1365,
					y1: 75.002,
					x2: 67.1365,
					y2: 89.583,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A3E635" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#84CC16"
					})]
				})
			] })
		]
	})
});
export default SvgA3;
